import React from 'react';
import {
    Box,
    Typography,
    Paper,
    IconButton,
    Backdrop,
    Slide,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PrimaryButton } from './index';
import axiosClient from '../services/axiosClient';
import { ThemeProvider } from '@mui/material/styles';
import theme from '../styles/theme';

interface DeactivateListingOverlayProps {
    open: boolean;
    onClose: () => void;
    listingId: string;
    isDesktop: boolean;
    onSuccess?: () => void;
}

const DeactivateListingOverlay = ({ open, onClose, listingId, isDesktop, onSuccess }: DeactivateListingOverlayProps) => {
    const handleDeactivate = async () => {
        try {
            const response = await axiosClient.patch(`/listings/${listingId}/deactivate`);
            if (response.data.success) {
                onSuccess?.();
                onClose();
            }
        } catch (error) {
            console.error('Failed to deactivate listing:', error);
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <Backdrop
                open={open}
                sx={{
                    zIndex: theme => theme.zIndex.drawer + 1,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                }}
                onClick={(e) => {
                    // Only close if the backdrop itself is clicked
                    if (e.target === e.currentTarget) {
                        onClose();
                    }
                }}
            >
                <Slide direction="up" in={open} mountOnEnter unmountOnExit>
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            display: 'flex',
                            justifyContent: 'center',
                            width: '100%'
                        }}
                    >
                        <Paper
                            sx={{
                                p: 3,
                                borderRadius: 6,
                                width: isDesktop ? '500px' : '100%',
                                maxWidth: isDesktop ? '500px' : '100%',
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                margin: isDesktop ? 'auto' : 0,
                                position: 'relative',
                            }}
                        >
                            <IconButton
                                onClick={onClose}
                                sx={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '12px',
                                }}
                            >
                                <CloseIcon />
                            </IconButton>

                            <Typography variant="h6" fontWeight="bold" gutterBottom sx={{ mb: 3, pr: 4 }}>
                                Congrats on finding tenants!
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 3 }}>
                                Closing this listing will cancel all tours and notify applicants the unit is filled. Confirm proceed?
                            </Typography>

                            <Box mt={3}>
                                <PrimaryButton
                                    fullWidth
                                    onClick={handleDeactivate}
                                >
                                    Confirm to proceed
                                </PrimaryButton>
                            </Box>
                        </Paper>
                    </Box>
                </Slide>
            </Backdrop>
        </ThemeProvider>
    );
};

export default DeactivateListingOverlay;